var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
import iconTypes from './StepIconTypes';
var buildStyle = function (_a, _b) {
    var backgroundColor = _a.backgroundColor, font = _a.font;
    var readingDirection = _b.readingDirection;
    return {
        stepWrapper: {
            display: 'flex',
            width: '100%',
            backgroundColor: backgroundColor.base
        },
        main: {
            margin: '0',
            width: '100%',
            padding: '0'
        },
        button: {
            margin: '0',
            border: 'none',
            width: '100%',
            background: 'transparent',
            padding: '0',
            color: font.color.base,
            fontFamily: font.base.family,
            textAlign: 'left',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row'
        },
        stepContainer: {
            main: {
                padding: '16px 0',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                zIndex: 100,
                margin: '4px 0',
                width: '100%'
            },
            collapsed: {
                padding: '8px 0'
            }
        },
        nameWrapper: {
            base: __assign({ margin: '0 8px', fontSize: font.base.size.m, fontWeight: font.base.weight.regular, pointerEvents: 'none', color: font.color.soft }, readingDirection),
            error: {
                color: font.color.danger.base
            },
            current: {
                color: font.color.base
            },
            hover: {
                color: font.color.hover
            }
        },
        topSpacer: {
            width: 4,
            height: 16,
            margin: '0 10px -16px 10px',
            backgroundColor: backgroundColor.interactive.active,
            pointerEvents: 'none'
        },
        bottomSpacer: {
            width: 4,
            height: 16,
            margin: '-16px 10px 0 10px',
            backgroundColor: backgroundColor.interactive.active,
            pointerEvents: 'none'
        },
        completedSpacer: {
            backgroundColor: backgroundColor.accent.fill.base
        },
        subHeadingWrapper: {
            fontSize: font.base.size.xs,
            color: font.color.soft,
            position: 'absolute',
            top: 40,
            left: 48
        }
    };
};
var useStyle = function (_a) {
    var isRtl = _a.isRtl, isCurrentStep = _a.isCurrentStep, status = _a.status, hover = _a.hover, collapsed = _a.collapsed;
    var builtStyle = useBuildStyleWithTheme(buildStyle, { isRtl: isRtl });
    if (!builtStyle) {
        return {
            stepWrapper: {},
            main: {},
            stepContainer: {},
            nameWrapper: {},
            topSpacer: {},
            bottomSpacer: {},
            subHeadingWrapper: {},
            button: {}
        };
    }
    var stepWrapper = builtStyle.stepWrapper, main = builtStyle.main, stepContainer = builtStyle.stepContainer, nameWrapper = builtStyle.nameWrapper, topSpacer = builtStyle.topSpacer, bottomSpacer = builtStyle.bottomSpacer, completedSpacer = builtStyle.completedSpacer, subHeadingWrapper = builtStyle.subHeadingWrapper, button = builtStyle.button;
    return {
        stepWrapper: stepWrapper,
        main: main,
        stepContainer: __assign(__assign({}, stepContainer.main), (collapsed && stepContainer.collapsed)),
        nameWrapper: __assign(__assign(__assign(__assign({}, nameWrapper.base), (status === iconTypes.error && nameWrapper.error)), (isCurrentStep && nameWrapper.current)), (hover && nameWrapper.hover)),
        topSpacer: __assign(__assign({}, topSpacer), ((status === iconTypes.completed || isCurrentStep) && completedSpacer)),
        bottomSpacer: __assign(__assign({}, bottomSpacer), ((status === iconTypes.completed || isCurrentStep) && completedSpacer)),
        subHeadingWrapper: subHeadingWrapper,
        button: button
    };
};
export default useStyle;
